<template>
  <div class="wrap">
    <div>
      <div class="container">
        <div class="login_wrap">
          <div class="tab_area">
            <div
              id="login_authentication"
              class="login_tab"
              :class="{ on: activeTab === 'authentication' }"
              @click="changeTab('authentication')"
            >
              간편인증 로그인
            </div>
            <div
              id="login_id"
              class="login_tab"
              :class="{ on: activeTab === 'id_pw' }"
              @click="changeTab('id_pw')"
            >
              ID / PW 로그인
            </div>
            <div
              id="login_qr"
              class="login_tab"
              :class="{ on: activeTab === 'qr' }"
              @click="changeTab('qr')"
            >
              모바일 학생증(QR) 로그인
            </div>
          </div>
          <!-- ID/PW 로그인 폼 -->
          <div v-if="activeTab === 'id_pw'" class="login_form login_form_id">
            <div class="title">라온 메타데미에 오신 것을 환영합니다.</div>
            <div class="form_area">
              <form @submit.prevent="dataSave">
                <table class="table_style_1">
                  <tbody>
                    <tr>
                      <th>아이디</th>
                      <td>
                        <input
                          id="user_id"
                          ref="userIDFocus"
                          v-model="userID"
                          type="text"
                          maxlength="15"
                          placeholder="아이디를 입력해주세요."
                          @input="checkIDLength"
                        />
                        <span
                          v-if="minIDLenght"
                          class="user_id_span"
                          style="display: inline !important"
                          >최소 5자 이상 입력이 필요합니다.</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <th>비밀번호</th>
                      <td class="pw_area">
                        <input
                          ref="userPWFocus"
                          v-model="userPW"
                          :type="passwordType"
                          maxlength="20"
                          placeholder="비밀번호를 입력해주세요."
                          @blur="checkPWLength"
                        />
                        <span
                          v-if="minPWLenght"
                          class="user_pw_span"
                          style="display: inline !important"
                          >최소 8자 이상 입력이 필요합니다.</span
                        >
                        <div
                          v-if="changeIcon"
                          class="eye"
                          @click="togglePasswordVisibility"
                        >
                          <img :src="eyeIconSrcOff" alt="" />
                        </div>
                        <div
                          v-else
                          class="eye"
                          @click="togglePasswordVisibility"
                        >
                          <img :src="eyeIconSrcOn" alt="" />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- 추가구현 해야함, 로그인 상태 유지에 이슈 발생해서 막아뒀음 -->
                <!-- 로그인 유지 말고 아이디 저장으로 변경 될 가능성 높음.-->
                <!-- <div class="check_area">
                  <input id="staySigned" v-model="staySigned" type="checkbox" />
                  <label for="staySigned"></label>
                  <label for="staySigned" class="staySigned"
                    >로그인 상태 유지하기</label
                  >
                </div> -->
                <!-- <div class="warning">
                  * 현재는 기관 및 기업 아닌 개인회원은 가입 및 로그인이
                  불가합니다.
                </div> -->
                <div class="btn_area">
                  <input type="submit" class="btn_orange" value="로그인" />
                </div>
              </form>
            </div>
            <div class="find_area">
              <ul>
                <li><a href="/find_id">아이디 찾기</a></li>
                <li>|</li>
                <li><a href="/find_pw">비밀번호 찾기</a></li>
              </ul>
            </div>
            <div class="join_area" @click="moveToUrl('/join')">
              <img src="../../public/assets/images/newAlert.png" />
              <p>아직 회원이 아닌가요? > 회원가입하기</p>
            </div>
          </div>

          <form id="qr_form" action="/login_verification" method="POST">
            <div v-if="activeTab === 'qr'" class="login_form login_form_qr">
              <div class="title">라온 메타데미에 오신 것을 환영합니다.</div>
              <div id="qr_img_div" class="qr_img_area">
                <div id="qr_imgs" class="imgs">
                  <img
                    v-if="qrImage"
                    :src="qrImage"
                    alt="QRcode"
                    class="qr_img"
                  />
                </div>
                <div id="countdown" class="count"></div>
                <div class="retry">
                  <div id="did_retry" @click="didStart">
                    <img src="/assets/images/icon/retry.png" alt="" />
                    <span>재시도 하기</span>
                  </div>
                </div>
                <div class="txt">
                  발급받은 모바일학생증을 이용하여 로그인을<br />
                  진행하오니 위쪽 QR 코드를 스캔하여<br />
                  모바일학생증을 제출 해주시기 바랍니다.
                </div>
              </div>
            </div>
          </form>
          <!-- QR 로그인 폼 -->

          <!-- 간편인증 로그인 폼 -->
          <form id="oacx_form" name="CXWindow" @submit.prevent="oacxPopup()">
            <div
              v-if="activeTab === 'authentication'"
              class="login_form login_form_authentication"
            >
              <div class="title">라온 메타데미에 오신 것을 환영합니다.</div>
              <div class="authentication">
                <div>
                  <img src="/assets/images/authentication/kakao.png" alt="" />
                  <img
                    src="/assets/images/authentication/kakaobank.png"
                    alt=""
                  />
                  <img src="/assets/images/authentication/toss.png" alt="" />
                  <img src="/assets/images/authentication/ss.png" alt="" />
                  <img src="/assets/images/authentication/sh.png" alt="" />
                  <img src="/assets/images/authentication/payco.png" alt="" />
                </div>
                <div>
                  <img src="/assets/images/authentication/pass.png" alt="" />
                  <img src="/assets/images/authentication/kb.png" alt="" />
                  <img src="/assets/images/authentication/naver.png" alt="" />
                  <img src="/assets/images/authentication/wr.png" alt="" />
                  <img src="/assets/images/authentication/hn.png" alt="" />
                  <img
                    src="/assets/images/authentication/mobileid.png"
                    alt=""
                  />
                </div>
              </div>
              <div class="txt_area">
                간편인증을 이용하시면 아이디/비밀번호 없이 로그인이 가능합니다.
              </div>
              <!-- <div class="warning">
                * 현재는 기관 및 기업 아닌 개인회원은 가입 및 로그인이
                불가합니다.
              </div> -->
              <div class="btn_area" style="cursor: default">
                <button
                  id="calloacx"
                  type="button"
                  class="btn_orange"
                  style="cursor: pointer"
                  @click="handleCallOacx"
                >
                  간편인증 로그인
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="Modals">
    <ModalAlertLoginPage
      :alertMsg="errMsg"
      :isOpen="errStatus"
      :isLoginPage="setLoginAlert"
      @update:isOpen="updateStatus"
      @check:isLoginPage="focusToInput"
    />
  </div>
</template>

<script>
import { ref, onUnmounted } from 'vue'
// import Cookies from 'vue-cookies'
import { loadLoginQr, loginId, loadOacxPopup, loginOacx } from '../api/loginout'
import ModalAlertLoginPage from '../components/ModalAlertLoginPage.vue'

export default {
  name: 'LoginViews',
  components: {
    ModalAlertLoginPage,
  },
  setup() {
    const errMsg = ref('')
    const errStatus = ref(false)
    const setLoginAlert = ref(false)
    const activeTab = ref('authentication') // Default tab
    const userID = ref('')
    const userPW = ref('')
    const minIDLenght = ref(false)
    const minPWLenght = ref(false)

    const passwordType = ref('password')
    const staySigned = ref(false)

    const eyeIconSrc = ref('/assets/images/icon/eye_off.png')
    const eyeIconSrcOff = ref('/assets/images/icon/eye_off.png')
    const eyeIconSrcOn = ref('/assets/images/icon/eye_on.png')
    const changeIcon = ref(true)
    const qrData = ref('')
    const qrImage = ref('')
    const intervalId = ref(null)
    let oacxStatusCheck = null
    const oacxdata = ref(null)
    const userIDFocus = ref(null)
    const userPWFocus = ref(null)
    const updateStatus = () => {
      errStatus.value = false
    }
    const focusToInput = () => {
      setLoginAlert.value = false
      if (!userID.value) {
        userIDFocus.value.focus()
      } else if (!userPW.value) {
        userPWFocus.value.focus()
      }
    }
    const checkIDLength = () => {
      minIDLenght.value = userID.value.length < 5
    }

    const checkPWLength = () => {
      minPWLenght.value = userPW.value.length < 8
    }
    // const checkIDLength = () => {
    //   // if (userID.value.length < 5 || userID.value.length > 15) {
    //   if (userID.value.length < 5) {
    //     minIDLenght.value = true
    //     // return '최소 5자 이상, 최대 15자 이하로 입력해주세요.'
    //   }
    //
    // }
    // const checkPWLength = () => {
    //   // if (userPW.value.length < 8 || userPW.value.length > 20) {
    //   if (userPW.value.length < 8) {
    //     minPWLenght.value = true
    //     // return '최소 8자 이상, 최대 20자 이하로 입력해주세요.'
    //   }
    // }
    const changeTab = (tab) => {
      activeTab.value = tab
      if (tab === 'qr') {
        // eslint-disable-next-line no-use-before-define
        didStart()
      } else {
        clearInterval(intervalId)
      }
      if (tab === 'id_pw' || tab === 'qr') {
        // eslint-disable-next-line no-use-before-define
        oacx_stop()
      }
    }
    const moveToUrl = (url) => {
      window.location.href = url
    }
    const togglePasswordVisibility = () => {
      if (passwordType.value === 'password') {
        passwordType.value = 'text'
        eyeIconSrc.value = '/assets/images/icon/eye_on.png'
        changeIcon.value = !changeIcon.value
      } else {
        // console.log('3', eyeIconSrc.value)
        eyeIconSrc.value = '/assets/images/icon/eye_off.png'
        changeIcon.value = !changeIcon.value
      }
    }

    const dataSave = async () => {
      // console.log('staySigned', staySigned.value)
      const codeResult = await loginId(userID, userPW, staySigned.value)
      if (codeResult) {
        switch (codeResult) {
          case 'MB20001404':
            errStatus.value = true
            setLoginAlert.value = true
            errMsg.value = '아이디와 비밀번호를 모두 입력해주세요'
            break
          case 'MB20002404':
            // 해당 회원을 찾을 수 없습니다.
            errStatus.value = true
            setLoginAlert.value = true
            errMsg.value =
              '아이디 또는 비밀번호가 올바르지 않습니다.<br>입력 내용을 다시 확인해주세요.'
            break
          case 'MB20003400':
            // 비밀번호가 잘못되었습니다.
            errStatus.value = true
            setLoginAlert.value = true
            errMsg.value =
              '아이디 또는 비밀번호가 올바르지 않습니다.<br>입력 내용을 다시 확인해주세요.'
            break
          case 'MB20005400':
            // 탈퇴신청된 계정
            errStatus.value = true
            setLoginAlert.value = true
            errMsg.value =
              '탈퇴 신청된 계정입니다. <br> 해당 계정 사용을 원하시면 관리자에게 문의해주세요.'
            break
          case 'MB20004400':
            // 탈퇴처리 완료된 계정
            errStatus.value = true
            setLoginAlert.value = true
            errMsg.value =
              '탈퇴된 계정입니다.<br> 재가입을 원하시면 관리자에게 문의해주세요.'
            break
          default:
            break
        }
      }
    }

    const didStart = async () => {
      const isRun = document.getElementById('login_qr').getAttribute('is_run')
      if (isRun === 'false' || isRun === null) {
        const qrResponse = await loadLoginQr()
        qrData.value = qrResponse
        qrImage.value = qrData.value.qr_image
        intervalId.value = setInterval(() => {}, 3000)
      }
    }

    // eslint-disable-next-line camelcase
    const oacx_stop = () => {
      clearInterval(oacxStatusCheck)
      oacxStatusCheck = null
    }
    const handleCallOacx = async () => {
      try {
        oacxdata.value = await loadOacxPopup()
        const oacxWindow = window.open(
          '/oacx',
          'OacxPopupViews',
          'width=800,height=728'
        )
        if (oacxWindow === null) {
          alert(
            ' ※ 윈도우 XP SP2 또는 인터넷 익스플로러 7 사용자일 경우에는 \n    화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다. \n\n※ MSN,야후,구글 팝업 차단 툴바가 설치된 경우 팝업허용을 해주시기 바랍니다.'
          )
          return
        }
        if (oacxdata.value.code === 'MB32000200') {
          localStorage.setItem('baseUrl', oacxdata.value.content.popup_base_url)
          localStorage.setItem('certInfo', oacxdata.value.content.cert_info)
          localStorage.setItem(
            'callbackUrl',
            oacxdata.value.content.callback_url
          )
          localStorage.setItem('sid', oacxdata.value.content.sid)
          localStorage.setItem('chkPoint', 'trigger')
        }
        // eslint-disable-next-line consistent-return
        const handleMessage = async (event) => {
          if (event.data === 'popupClosed') {
            const getResult = await loginOacx()
            // console.log(getResult)
            if (getResult && getResult.status_code) {
              if (getResult.code !== 'MB20000200') {
                if (getResult.code === 'MB20022404') {
                  // 비회원의 경우 발생하는 오류
                  errStatus.value = true
                  errMsg.value =
                    '가입되지 않았거나 본인인증이 완료되지 않은 회원정보입니다. <br>  ID/PW로 로그인 하거나 회원가입을 진행해주세요.'
                  // errMsg.value =
                  //   '존재하지 않는 회원입니다. <br>  회원가입을 진행해주세요.'
                }
                return 0
              }
            }
            if (event.origin !== window.location.origin) {
              return 0
            }
            if (event.data === 'popupClosed') {
              window.removeEventListener('message', handleMessage)
            }
            window.removeEventListener('message', handleMessage)
          }
        }
        // eslint-disable-next-line consistent-return
        window.addEventListener('message', handleMessage)
      } catch (err) {
        console.log(err)
      }

      // oacxdata.value = await loadOacxPopup()
      // const oacxWindow = window.open(
      //   '/oacx',
      //   'OacxPopupViews',
      //   'width=800,height=728'
      // )
      // if (oacxdata.value.code === 'MB32000200') {
      //   localStorage.setItem('baseUrl', oacxdata.value.content.popup_base_url)
      //   localStorage.setItem('certInfo', oacxdata.value.content.cert_info)
      //   localStorage.setItem('callbackUrl', oacxdata.value.content.callback_url)
      //   localStorage.setItem('sid', oacxdata.value.content.sid)
      //   localStorage.setItem('chkPoint', 'trigger')
      // }
      // // eslint-disable-next-line consistent-return
      // oacxStatusCheck = setInterval(async () => {
      //   const getResult = await loginOacx()
      //   if (getResult && getResult.status_code) {
      //     if (getResult.code !== 'MB20000200') {
      //       if (getResult.code === 'MB20022404') {
      //         // 비회원의 경우 발생하는 오류
      //         errStatus.value = true
      //         errMsg.value =
      //           '존재하지 않는 회원입니다. <br>  회원가입을 진행해주세요.'
      //       }
      //       return 0
      //     }
      //     clearInterval(oacxStatusCheck)
      //   }
      // }, 2000)
      // const handleMessage = (event) => {
      //   if (event.origin !== window.location.origin) {
      //     return
      //   }
      //   if (event.data === 'popupClosed') {
      //     // clearInterval(oacxStatusCheck)
      //     window.removeEventListener('message', handleMessage)
      //   }
      // }

      // window.addEventListener('message', handleMessage)
      // const checkPopupClosed = setInterval(() => {
      //   if (oacxWindow.closed) {
      //     clearInterval(checkPopupClosed)
      //     clearInterval(oacxStatusCheck)
      //     // window.removeEventListener('message', handleMessage)
      //   }
      // }, 3000)
    }

    // const handleCallOacx = async () => {
    //   oacxdata.value = await loadOacxPopup()
    //   const oacxWindow = window.open(
    //     '/oacx',
    //     'OacxPopupViews',
    //     'width=800,height=728'
    //   )
    //   if (oacxdata.value.code === 'MB32000200') {
    //     localStorage.setItem('baseUrl', oacxdata.value.content.popup_base_url)
    //     localStorage.setItem('certInfo', oacxdata.value.content.cert_info)
    //     localStorage.setItem('callbackUrl', oacxdata.value.content.callback_url)
    //     localStorage.setItem('sid', oacxdata.value.content.sid)
    //     localStorage.setItem('chkPoint', 'trigger')
    //   }
    //   // eslint-disable-next-line consistent-return
    //   oacxStatusCheck = setInterval(async () => {
    //     const getResult = await loginOacx()
    //     if (getResult && getResult.status_code) {
    //       if (getResult.code !== 'MB20000200') {
    //         if (getResult.code === 'MB20022404') {
    //           // 비회원의 경우 발생하는 오류
    //           errStatus.value = true
    //           errMsg.value =
    //             '존재하지 않는 회원입니다. <br>  회원가입을 진행해주세요.'
    //         }
    //         return 0
    //       }
    //       clearInterval(oacxStatusCheck)
    //     }
    //   }, 2000)
    //   const handleMessage = (event) => {
    //     if (event.origin !== window.location.origin) {
    //       return
    //     }
    //     if (event.data === 'popupClosed') {
    //       // clearInterval(oacxStatusCheck)
    //       window.removeEventListener('message', handleMessage)
    //     }
    //   }

    //   window.addEventListener('message', handleMessage)
    //   const checkPopupClosed = setInterval(() => {
    //     if (oacxWindow.closed) {
    //       clearInterval(checkPopupClosed)
    //       clearInterval(oacxStatusCheck)
    //       // window.removeEventListener('message', handleMessage)
    //     }
    //   }, 3000)
    // }

    onUnmounted(() => {
      clearInterval(intervalId)
      clearInterval(oacxStatusCheck)
      // window.removeEventListener('message', handleMessage)
    })

    return {
      errMsg,
      errStatus,
      setLoginAlert,

      activeTab,
      userID,
      userPW,
      userIDFocus,
      userPWFocus,
      staySigned,
      passwordType,
      changeTab,
      togglePasswordVisibility,
      dataSave,
      didStart,
      handleCallOacx,

      updateStatus,
      focusToInput,

      eyeIconSrc,
      eyeIconSrcOff,
      eyeIconSrcOn,
      changeIcon,
      qrData,
      qrImage,
      minIDLenght,
      minPWLenght,
      checkIDLength,
      checkPWLength,

      moveToUrl,
    }
  },
}
</script>
<style scoped>
/* Add your styles here */
</style>
